import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import filter from '@Components/Grid/utils/filter';
import { useGlobalStore } from '@Stores/global';

export default function useFilters() {
  const { content_type } = useParams()
  const { siteSettings: { useThemeConfig } } = useGlobalStore()
  const contentTypes = useThemeConfig('types')
  const hasSettings = !!contentTypes?.[content_type]

  return useMemo(() => [
    content_type !== 'page' && hasSettings ? filter
      .options.store('tags', 'Tags', 'cms/tags', { params: { content_type } })
      .multi(true) : null,
    filter.boolean('restricted', 'Restricted'),
    filter.boolean('active', 'Active'),
  ].filter(Boolean), [content_type, hasSettings])
}
